import React from 'react';
import PropTypes from 'prop-types';

function GridContainer({children, style, onClick, href, target, rel}) {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        ...style,
      }}
    >
      {children}
    </div>
  );
}

GridContainer.propTypes = {
  children: PropTypes.node,
  style: PropTypes.shape({}),
  onClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
};

export default GridContainer;
